// extracted by mini-css-extract-plugin
export var layoutContainer = "_9m-0";
export var layoutContainerNoRounding = "_9m-6";
export var layoutContainerOpen = "_9m-5";
export var layoutContainerResizing = "_9m-1";
export var mainContent = "_9m-2";
export var resizeDivider = "_9m-3";
export var slidePanel = "_9m-4";